@if (historyView) {
  <div class="quick-view quick-view--wide" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="historyView = null" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <section>
      <div class="quick-view__top">{{ historyView.historyType | titlecase }} historik</div>
      <div class="data">
        <div class="data__lbl">Historik for</div>
        <div class="data__val">
          {{ historyView.title }}
        </div>
      </div>
      <hr />
      <app-history [entityId]="historyView.entityId" [entityType]="historyView.historyType"></app-history>
    </section>
  </div>
}
